import React from 'react';
import { SimulationConfig } from './types';

interface SimulationFooterProps {
  config: SimulationConfig;
  currentRgb: string;
}

export const SimulationFooter: React.FC<SimulationFooterProps> = ({ config, currentRgb }) => (
  <div className="absolute left-1/2 -translate-x-1/2 pointer-events-none text-center z-10 w-full" style={{ 
    top: `calc(50% + ${config.containerRadius}px + 2.5rem)`,
    fontSize: `${config.footerFontSize}px`
  }}>
    <p className="font-black uppercase tracking-tighter transition-all duration-300" style={{ color: config.rgbLighting ? currentRgb : config.footerTextColor }}>
      {config.footerText}
    </p>
  </div>
);